import { BillingType, BillingPeriod } from './pricing.types.js';
import { planOrder, planOrderWithDuration, getExtensiveLifetimePlan, getLifetimePlan, getPlans } from './pricing.config.js';

const isPlanWithDurationBelow = (plan1, plan2) => {
  return planOrderWithDuration.indexOf(plan1) < planOrderWithDuration.indexOf(plan2);
};
const isPlanBelow = (plan1, plan2) => {
  return planOrder.indexOf(plan1) < planOrder.indexOf(plan2);
};
const isSubscribedPlan = (plan) => {
  return !(plan ?? "free").startsWith("free");
};
const getFullTierFromUser = (user) => {
  if (!user.subscription.tier) return "free";
  if (user.subscription.tier === "lifetime" || user.subscription.tier === "free") return user.subscription.tier;
  return `${user.subscription.tier}-${user.subscription.billingCycle}`;
};
const getCurrentStripePlanId = (prices, billingPeriod) => {
  switch (prices.type) {
    case BillingType.Recurring:
      return billingPeriod === BillingPeriod.Monthly ? prices.stripePlanIdMonthly : prices.stripePlanIdYearly;
  }
};
const getFullTierFromPlan = ({ name, prices }, billingPeriod) => {
  const planId = getCurrentStripePlanId(prices, billingPeriod);
  if (!planId) return "free";
  if (name === "lifetime" || name === "free") return name;
  return `${name}-${billingPeriod}`;
};
const getPlanByName = (name, extensive = false) => {
  if (name === "lifetime") return extensive ? getExtensiveLifetimePlan() : getLifetimePlan();
  return getPlans().find((plan) => plan.name === name.split("-")[0]);
};
const getPlanByOfferingId = (offeringId) => {
  return getPlans().find((plan) => plan.prices.revenueCatOfferingId === offeringId);
};
const getPlanTitle = (name) => {
  if (name === "lifetime") return getLifetimePlan().title;
  return getPlans().find((plan) => plan.name === name.split("-")[0])?.title;
};

export { getCurrentStripePlanId, getFullTierFromPlan, getFullTierFromUser, getPlanByName, getPlanByOfferingId, getPlanTitle, isPlanBelow, isPlanWithDurationBelow, isSubscribedPlan };
//# sourceMappingURL=pricing.utils.js.map
